import type { BivariateDataset } from './e3-spurious';

export const SLEEP_VS_REACTION: BivariateDataset = {
  id: 'real-sleep-vs-reaction-time',
  labelKey: 'dataset.real-sleep-vs-reaction-time.label',
  descKey: 'dataset.real-sleep-vs-reaction-time.desc',
  xLabelKey: 'column.sleep_hours.label',
  yLabelKey: 'column.reaction_ms.label',
  points: [
    { x: 4.0, y: 410 },
    { x: 4.5, y: 395 },
    { x: 5.0, y: 380 },
    { x: 5.5, y: 365 },
    { x: 6.0, y: 350 },
    { x: 6.5, y: 340 },
    { x: 7.0, y: 320 },
    { x: 7.5, y: 310 },
    { x: 8.0, y: 300 },
    { x: 8.5, y: 290 },
    { x: 9.0, y: 275 },
    { x: 9.5, y: 270 },
    { x: 5.0, y: 360 },
    { x: 6.0, y: 330 },
    { x: 7.0, y: 305 },
    { x: 8.0, y: 285 },
    { x: 9.0, y: 280 },
    { x: 6.5, y: 320 },
    { x: 7.5, y: 295 },
    { x: 8.5, y: 275 },
  ],
};

export const REAL_PRESETS = [SLEEP_VS_REACTION] as const;
